/**
 * SEO(검색엔진 최적화)를 위한 메타 태그 관리 컴포넌트
 * react-helmet을 사용하여 도메인별 title을 동적으로 설정합니다.
 * description, keywords, Open Graph 등은 index.html에서 에스이임파워 기준으로 정적 설정되어 있습니다.
 */

import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

/**
 * MyHelmet 컴포넌트
 * 도메인에 따라 사이트명을 자동으로 감지하여 title을 동적으로 설정합니다.
 * - xn--9t4b11dwvagtoc689f.kr (에스이임파워.kr) → "에스이임파워"
 * - xn--2e0by4j8qi0bt02giur.kr (중구행복돌봄.kr) → "중구행복돌봄센터"
 * - seempower.kr, localhost 등 기타 → 기본값 "에스이임파워"
 *
 * @example
 * <MyHelmet />
 */
const MyHelmet = () => {
  const location = useLocation();

  // 현재 접속한 도메인을 자동으로 감지
  const currentDomain = typeof window !== 'undefined'
    ? `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`
    : "https://xn--9t4b11dwvagtoc689f.kr"; // SSR 기본값 (에스이임파워.kr)

  const currentUrl = `${currentDomain}${location.pathname}`;

  // 도메인별 사이트명 결정
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'xn--9t4b11dwvagtoc689f.kr';

  // 퓨니코드 도메인 감지
  // xn--2e0by4j8qi0bt02giur.kr = 중구행복돌봄.kr
  // xn--9t4b11dwvagtoc689f.kr = 에스이임파워.kr
  const siteName = hostname.includes('xn--2e0by4j8qi0bt02giur') || hostname.includes('중구행복돌봄')
    ? '중구행복돌봄센터'
    : '에스이임파워';

  return (
    <Helmet>
      {/* 도메인별 사이트명으로 title 설정 (동적) */}
      <title>{siteName}</title>

      {/* Canonical URL - 중복 콘텐츠 방지 (동적) */}
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
};

export default MyHelmet;
